import { Tabs, Divider } from 'antd';
import { UnorderedListOutlined, CalendarOutlined } from '@ant-design/icons';
import constants from '../../constants/constants';
import ClickMonthReport from './ClickMonthReport';
import { useContext, useEffect, useState } from 'react';
import ClickDailyReport from './ClickDayReport';
import ClickSpendPerJob from './ClickSpendPerJob';
import ClickOccupationReport from './ClickOccupationReport';
import { trackPageAccess } from '../../globalFunctions/GlobalFunctions';
import { CommonContext } from '../../Context';
const { TabPane } = Tabs;

const ClickReportTabs = () => {
  //Variable declaration
	const [dateValues,setDateValues]=useState(null);
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;

  useEffect(() => {
    trackPageAccess(buyerId,window.location.href)
  }, []);

	//Functions
	//Functon to set changed date value
	const changeDate=(selectedDate)=>{
		setDateValues(selectedDate);
	}
		
	return (
		<div>
      <div className='uppercase font-bold text-xl'>Click Report</div>
			<Divider className='my-3'/>
			<Tabs defaultActiveKey="2" >
      <TabPane
        tab={ <span className='uppercase'><CalendarOutlined className='text-xl' />{constants.AppReportTab2}</span> }
        key={2}>
				<ClickMonthReport changeDate={changeDate} dateSelectedValue={dateValues}/>
      </TabPane>
			<TabPane
        tab={ <span className='uppercase'><UnorderedListOutlined className='text-xl' />{constants.AppReportTab1}</span> }
        key={1}
      >
				<ClickDailyReport changeDate={changeDate} dateSelectedValue={dateValues}/>
      </TabPane>
			<TabPane
        tab={ <span className='uppercase'><UnorderedListOutlined className='text-xl' />{constants.AppReportTab5}</span> }
        key={3}
      >
				<ClickSpendPerJob changeDate={changeDate} dateSelectedValue={dateValues}/>
      </TabPane>
			<TabPane
        tab={ <span className='uppercase'><CalendarOutlined className='text-xl' />{constants.AppReportTab3}</span> }
        key={4}
      >
        <ClickOccupationReport changeDate={changeDate} dateSelectedValue={dateValues}/>
      </TabPane>
			</Tabs>
		</div>
	);
};

export default ClickReportTabs;